import { API } from "aws-amplify";
import axios from 'axios';
import "containers/common/List.css";
import React, { Component } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import ReactTable from "react-table";
import 'react-table/react-table.css';



//import Moment from "moment";

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class CPIRatesList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            cpirates: [],            
            filter: {},
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false
        };

        
    }
    

    async componentDidMount() {
        
        this.setState({ isLoading: true });      
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        
        try {
            const cpirates = await this.getCPIRates();
            this.setState({ cpirates });
            
        } catch (e) {
            alert(e);
        }

        this.setState({ isLoading: false });      
    }

    
    componentWillUnmount() {
        source.cancel();
        
        
        this.setState({ cpirates: [] });        
    }


    
    async getCPIRates() {
        
        
        return API.get("colin", "/cpirates");
      
    }
    

    addRecord = async event => {
        let cpirates = [...this.state.cpirates];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        cpirates.unshift({
            cpi_id: null,
            year:"",
            match_quarter: null,
            june_quarter: null,
            september_quarter: null,
            december_quarter: null,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.setState({cpirates});
    }

    

    async saveRecord(record) {
        
        record.last_edited_by= this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                
                return API.post("colin", `/cpirates/new`, {
                    body: record
                });
                
                
            }
        }
    
        return API.put("colin", `/cpirates/${record["cpi_id"]}`, {
            body: record
        });
        
        

       
    }

    validateRecord(record) {

       
        if (record.year === "") {
            return [false,"Year cannot be blank. The record has not been saved"];
        }

        
       
        return [true,];
    }


    async handleDataSave(data) {
        try {
            return await this.saveRecord(data);


        } catch (e) {
            alert("Error saving");
        }
    }

    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let cpirates = [...this.state.cpirates];
        
        if (cellInfo.column.id === "country_code" && !cpirates[cellInfo.index].new_record)
        {
            alert("You cannot modify an existing country code");
            return
        }
        cpirates[cellInfo.index][cellInfo.column.id] = event.target.value;
        cpirates[cellInfo.index].modified = true;
        this.setState({cpirates});
    };
    handleNumberChange = (cellInfo, event) => {
        let cpirates = [...this.state.cpirates];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        cpirates[cellInfo.index][cellInfo.column.id] = Number(val);
        cpirates[cellInfo.index].modified = true;
        this.setState({cpirates});
    };
    handleCheckboxChange = (cellInfo, event) => {
        let cpirates = [...this.state.cpirates];
        cpirates[cellInfo.index][cellInfo.column.id] = event.target.checked;
        cpirates[cellInfo.index].modified = true;
        this.setState({cpirates});
    };

    handleDateChange = (cellInfo, event) => {
        let cpirates = [...this.state.cpirates];
        cpirates[cellInfo.index][cellInfo.column.id] = new Date(event);
        cpirates[cellInfo.index].modified = true;
        this.setState({cpirates});

    }

    handleSave = async (cellInfo, event) => {
        
        this.setState({ showAlert: false });
        let cpirates = [...this.state.cpirates];
        for (var i=0; i<cpirates.length; i++){
            const validation = this.validateRecord(cpirates[i]);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (cpirates[i].hasOwnProperty("modified")) {
                    if (cpirates[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (cpirates[i].hasOwnProperty("new_record")) {
                                if (cpirates[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(cpirates[i]);
                            if (result.result) {
                                cpirates[i].modified = false;
                                if (cpirates[i].hasOwnProperty("new_record")) {
                                    if (cpirates[i].new_record === true) {

                                        cpirates[i].id = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    cpirates[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }   
        if (cpirates[0].hasOwnProperty("sort_order")) {
            cpirates.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        
        this.setState({cpirates});

    }

    handleRegionChange = (cellInfo, event) => {
        let cpirates = [...this.state.cpirates];
        console.log(event);
        cpirates[cellInfo.index][cellInfo.column.id] = event.value;
        cpirates[cellInfo.index].modified = true;
        this.setState({cpirates});

    }

    renderEditable = cellInfo => {
        const cellValue = this.state.cpirates[cellInfo.index][cellInfo.column.id];


        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }
        }
    }

    
    
    
    
      
    
    renderTable(data) {
        const columns = [

            {
                id: 'cpi_id',
                Header: 'ID',
                maxWidth: 150,
                accessor: 'cpi_id'               
        },
        {
                id: 'year',
                Header: 'Year',
                maxWidth: 350,
                accessor: 'year' ,
                Cell: this.renderEditable                
        },
        {
                id: 'march_quarter',
                Header: 'March Quarter',
                maxWidth: 350,
                id: 'march_quarter',
                accessor: 'march_quarter' ,
                Cell: this.renderEditable                
        },
        {
                id: 'june_quarter',
                Header: 'June Quarter',
                maxWidth: 350,
                id: 'june_quarter',
                accessor: 'june_quarter' ,
                Cell: this.renderEditable                
        },
        {
                id: 'september_quarter',
                Header: 'September Quarter',
                maxWidth: 350,
                id: 'september_quarter',
                accessor: 'september_quarter' ,
                Cell: this.renderEditable                
        },
        {
                id: 'december_quarter',
                Header: 'December Quarter',
                maxWidth: 350,
                id: 'december_quarter',
                accessor: 'december_quarter' ,
                Cell: this.renderEditable                
        }
        
         
        ]          

        if (!data) {
            return null
        }
        else {
            
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={100}
                    sortable={false}
                />
            )
        }
    }

    
    renderComponent() {
        return (
            <div className="cpirates">
            <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                <Alert show={this.state.showAlert} variant="danger" dismissible >{this.state.errorMessage}</Alert>
                <Row >
                    <Col className="text-right" >                            
                            <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button>
                            
                                
                                
                        </Col>
                    </Row>

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                     
                        {!this.state.isLoading ? this.renderTable(this.state.cpirates) : this.renderTable(this.state.cpirates)  }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="CityscopeList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            
        </div>
    );
  }
}
